import React from 'react'

const ViewBrand = () => {
  return (
    <div>ViewBrand</div>
  )
}

export default ViewBrand;